module.exports = __webpack_public_path__ + "static/img/lang-kr.ded0a48.png";


//////////////////
// WEBPACK FOOTER
// ./src/statics/images/flag/lang-kr.png
// module id = P/YF
// module chunks = 44